import {Injectable} from "@angular/core";
import {HttpClient, HttpResponse} from "@angular/common/http";
import {Observable} from "rxjs";
import {environment} from "../../environments/environment";
import {ParamsBuildHelper} from "../helper/params-build-helper";
import {Wrapper} from "../model/dto/wrapper";

@Injectable({
  providedIn: 'root'
})
export class PdfService {
  constructor(private http: HttpClient) {
  }

  public getSTDReport(obligorId: string, dateTime: string): Observable<HttpResponse<Blob>> {
    return this.http.get<Blob>(environment.apiUrl + '/pdf-report/standard/' + obligorId +
      ParamsBuildHelper.buildGetParams(
        {
          'dateTime': dateTime
        }), {
      observe: 'response',
      responseType: 'blob' as 'json'
    });
  }

  public getPROReportLink(obligorId: string, actionType: string): string {
    return environment.apiUrl + '/pdf-report/pro/' + obligorId + ParamsBuildHelper.buildGetParams(
      {
        'actionType': actionType
      }
    );
  }

  public getPROReport(obligorId: string, actionType: string): Observable<HttpResponse<Blob>> {
    return this.http.get<Blob>(environment.apiUrl + '/pdf-report/pro/' + obligorId + ParamsBuildHelper.buildGetParams(
      {
        'actionType': actionType
      }
    ), {
      observe: 'response',
      responseType: 'blob' as 'json'
    });
  }

  public getMailLink(obligorId: string): Observable<Wrapper> {
    return this.http.get<Wrapper>(environment.apiUrl + '/pdf-report/email/' + obligorId);
  }
}
